import { useEffect, useState } from "react";

// ⏳ Écran de chargement (tour 34) : il n'apparaît que si le chargement dure plus de 300 ms, puis il
// reste au moins 500 ms, pour ne pas clignoter. Pas de durée minimale de chargement : un chargement
// rapide n'affiche jamais l'écran. Renvoie { loader, ready } : loader, afficher l'écran ; ready,
// afficher la page ; ni l'un ni l'autre pendant les 300 premières millisecondes (rien à l'écran).
export const LOADER_DELAY_MS = 300;
export const LOADER_MINIMUM_MS = 500;

export const useDelayedLoader = (loading, { delay = LOADER_DELAY_MS, minimum = LOADER_MINIMUM_MS } = {}) => {
  // Instant d'apparition de l'écran, null tant qu'il n'est pas affiché
  const [shownAt, setShownAt] = useState(null);

  // Chargement en cours depuis plus de « delay » : l'écran apparaît
  useEffect(() => {
    if (!loading) return undefined;
    const id = setTimeout(() => setShownAt((at) => at ?? Date.now()), delay);
    return () => clearTimeout(id);
  }, [loading, delay]);

  // Chargement fini, écran affiché : gardé jusqu'à « minimum » après son apparition
  useEffect(() => {
    if (loading || shownAt === null) return undefined;
    const left = minimum - (Date.now() - shownAt);
    if (left <= 0) {
      setShownAt(null);
      return undefined;
    }
    const id = setTimeout(() => setShownAt(null), left);
    return () => clearTimeout(id);
  }, [loading, shownAt, minimum]);

  const loader = shownAt !== null;
  return { loader, ready: !loading && !loader };
};
